import socket from './socket';

const getCardPointData = (cardId, headers) =>
  socket.get(`/cards/${cardId}/card-point-data`, undefined, headers);

const upsertCardPointData = (cardId, data, headers) =>
  socket.post(`/cards/${cardId}/card-point-data`, data, headers);

const completeCardPointData = (cardId, headers) =>
  socket.post(`/cards/${cardId}/card-point-data/complete`, undefined, headers);

const uncompleteCardPointData = (cardId, headers) =>
  socket.post(`/cards/${cardId}/card-point-data/uncomplete`, undefined, headers);

export default {
  getCardPointData,
  upsertCardPointData,
  completeCardPointData,
  uncompleteCardPointData,
};

